import { useContext, useEffect, useState } from 'react';
import { Snackbar, Box, Typography, Slide, SlideProps } from '@mui/material';
import SocketContext from '../../contexts/SocketContext';
import { PlaylistSwitchedResponse } from '../../socket_messages/PlaylistSwitched';
import { useTranslation } from '../../contexts/LanguageContext';

function SlideDown(props: SlideProps) {
    return <Slide {...props} direction="down" />;
}

export default function PlaylistSwitchedSnackbar() {
    const [open, setOpen] = useState(false);
    const [previousPlaylist, setPreviousPlaylist] = useState('');
    const [newPlaylist, setNewPlaylist] = useState('');
    const { SocketState } = useContext(SocketContext);
    const { t } = useTranslation();

    useEffect(() => {
        const handlePlaylistSwitched = (arg: PlaylistSwitchedResponse) => {
            setPreviousPlaylist(t(arg.previousPlaylist));
            setNewPlaylist(t(arg.newPlaylist));
            setOpen(true);
        };

        SocketState.socket?.on(PlaylistSwitchedResponse.Message, handlePlaylistSwitched);

        return () => {
            SocketState.socket?.off(PlaylistSwitchedResponse.Message, handlePlaylistSwitched);
        };
    }, [SocketState.socket, t]);

    return (
        <Snackbar
            open={open}
            autoHideDuration={5000}
            onClose={() => setOpen(false)}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            TransitionComponent={SlideDown}
        >
            <Box
                sx={{
                    background: 'linear-gradient(135deg, rgba(177, 234, 144, 0.15) 0%, rgba(193, 145, 255, 0.15) 100%)',
                    backdropFilter: 'blur(12px)',
                    border: '1px solid rgba(177, 234, 144, 0.3)',
                    borderRadius: '12px',
                    padding: 'clamp(10px, 2vw, 16px) clamp(16px, 3vw, 24px)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 'clamp(8px, 1.5vw, 12px)',
                    boxShadow: '0 4px 20px rgba(193, 145, 255, 0.2)',
                }}
            >
                <Typography sx={{ fontSize: 'clamp(1.1rem, 2.5vw, 1.4rem)', lineHeight: 1 }}>
                    🎵
                </Typography>
                <Box>
                    <Typography
                        sx={{
                            color: '#fff',
                            fontSize: 'clamp(0.75rem, 1.8vw, 0.9rem)',
                            textShadow: '0 0 12px rgba(193, 145, 255, 0.4)',
                        }}
                    >
                        <Typography component="span" sx={{ color: 'secondary.dark', fontWeight: 'bold', fontSize: 'inherit' }}>
                            {previousPlaylist}
                        </Typography>
                        {' '}{t('playlistExhausted')}
                    </Typography>
                    <Typography
                        sx={{
                            color: 'primary.main',
                            fontWeight: 'bold',
                            fontSize: 'clamp(0.8rem, 2vw, 1rem)',
                            textShadow: '0 0 12px rgba(177, 234, 144, 0.4)',
                        }}
                    >
                        → {newPlaylist}
                    </Typography>
                </Box>
            </Box>
        </Snackbar>
    );
}
